import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { AuthHttpInterceptor, AuthService } from '@auth0/auth0-angular';
import { combineLatest, Observable } from 'rxjs';
import { switchMap, take } from 'rxjs/operators';
import { UserService } from 'shared/services';
import { OrganizationType } from 'shared/services/authenticatedUser/types';

@Injectable()
export class AdminTokenHttpInterceptor implements HttpInterceptor {
    constructor(
        private auth0Interceptor: AuthHttpInterceptor,
        private auth0Service: AuthService,
        private userService: UserService
    ) {}

    intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        return this.auth0Interceptor.intercept(request, {
            handle: (req: HttpRequest<any>): Observable<HttpEvent<any>> => {
                const requestAuthHeader = req.headers.get('Authorization');
                if (!requestAuthHeader) {
                    return next.handle(req);
                }

                return combineLatest([this.auth0Service.user$, this.userService.user$]).pipe(
                    take(1),
                    switchMap(([auth0User, authenticatedUser]) => {
                        if (authenticatedUser?.accessToken && auth0User?.org_type === OrganizationType.Admin) {
                            return next.handle(
                                req.clone({
                                    headers: req.headers.set('Authorization', `Bearer ${authenticatedUser.accessToken}`)
                                })
                            );
                        }
                        return next.handle(req);
                    })
                );
            }
        });
    }
}
